'use client';

import { useEffect } from 'react';

import { loadAwinMasterTag } from '@/lib/analytics/awin/mastertag';

interface AwinMasterTagProps {
  advertiserId: string;
  nonce: string;
}

/** Loads the public Awin MasterTag after the server layout has approved this document. */
export function AwinMasterTag({ advertiserId, nonce }: AwinMasterTagProps) {
  useEffect(() => {
    void loadAwinMasterTag(advertiserId, nonce).catch(() => undefined);
  }, [advertiserId, nonce]);

  return null;
}
